import moment from 'moment';
import { GenRoleDefinition } from '../../generated/serverModels/GenRoleDefinition';
import { GenUser } from '../../generated/serverModels/GenUser';
import { Poc } from './poc';
import { UserPreferences } from './user-preferences';
import {ApiKey} from './apiKey';

export class User extends GenUser {
  static nonPocEmailExtension = ['.gov', '.mil'];
  public daysSincePasswordReset: number;
  public override pointOfContact: Poc;
  public override apiKeys: ApiKey[] = [];
  public preferences: UserPreferences;
  public override readonly fullName: string;

  constructor(user?: User) {
    super(user);

    if (user) {
      this.daysSincePasswordReset = Math.abs(moment().diff(this.lastPasswordReset, 'days'));
    }
    this.fullName = `${this.firstName} ${this.lastName}`;
  }

  public isAdmin(): boolean {
    return this.hasRole(GenRoleDefinition.ROLE_ADMIN);
  }

  public hasRole(role: GenRoleDefinition): boolean {
    return this.hasAnyRole([role]);
  }

  public hasAnyRole(roles: GenRoleDefinition[]): boolean {
    if (this.roles.includes(GenRoleDefinition.ROLE_ADMIN)) return true;

    return roles.some(roleToCheck => {
      return this.roles.includes(roleToCheck);
    });
  }

  public isEnabled(): boolean {
    return this.enabled && this.approved;
  }

}
